import styled, { css } from "styled-components";

export const StyledEditableField = styled.input<{
  isTaskCard?: boolean;
  numOfChars?: number;
}>`
  margin: 0;
  /* margin-right: 14px; */
  padding: 0;

  width: ${({ isTaskCard, numOfChars }) =>
    isTaskCard && numOfChars ? `${numOfChars * 14}px` : "100px"};
  max-width: ${({ isTaskCard }) => (isTaskCard ? "180px" : "100px")};

  height: auto;

  border: none;

  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-weight: ${({ isTaskCard, theme }) =>
    isTaskCard ? theme.fonts.weights.bold : theme.fonts.weights.bolder};

  &:focus {
    outline: none;
  }

  &:disabled {
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.background};
  }

  ${({ isTaskCard }) =>
    isTaskCard &&
    css`
      text-align: center;
    `};

  @media ${({ theme }) => theme.mq.md} {
    font-size: ${({ theme, isTaskCard }) => isTaskCard && theme.fonts.sizes.s};

    width: ${({ isTaskCard, numOfChars }) =>
      isTaskCard && numOfChars ? `${numOfChars * 16}px` : "100px"};
    max-width: ${({ isTaskCard }) => (isTaskCard ? "380px" : "100px")};
  }
`;
